export const ItemContact = (props) => {
    const contact = props.contact;
    return (
        <>
            <div class="boxed-widget margin-top-35">
                <div class="hosted-by-title">
                    <h4><span>Hosted by</span> <a href="pages-user-profile.html">{contact.name}</a></h4>
                    <a href="pages-user-profile.html" class="hosted-by-avatar"><img src={contact.avatar} alt="" /></a>
                </div>
                <ul class="listing-details-sidebar">
                    {contact.phone && (
                        <li><i class="sl sl-icon-phone"></i> {contact.phone}</li>
                    )}
                    {contact.web && (
                        <li><i class="sl sl-icon-globe"></i> <a href={contact.web} target="_blank" >{contact.web}</a></li>
                    )}
                    {contact.email && (
                        <li><i class="fa fa-envelope-o"></i> <a href={contact.email} target="_blank" >{contact.email}</a></li>
                    )}
                </ul>

                <ul class="listing-details-sidebar social-profiles">
                    {contact.facebook && (
                        <li><a href={contact.facebook} target="_blank" class="facebook-profile"><i class="fa fa-facebook-square"></i> Facebook</a></li>
                    )}
                    {contact.instagram && (
                        <li><a href={contact.instagram} target="_blank" class="instagram-profile"><i class="fa fa-instagram"></i> Instagram</a></li>
                    )}
                    {contact.youtube && (
                        <li><a href={contact.youtube} target="_blank" class="youtube-profile"><i class="fa fa-youtube-play"></i> Youtube</a></li>
                    )}
                    {contact.tiktok && (
                        <li><a href={contact.tiktok} target="_blank" class="tiktok-profile"><i class="fa fa-tiktok"></i> Tiktok</a></li>
                    )}
                    {contact.twitter && (
                        <li><a href={contact.twitter} target="_blank" class="twitter-profile"><i class="fa fa-twitter"></i> Twitter</a></li>
                    )}
                </ul>

                <div class="row with-forms  margin-top-0">

                    <div class="col-lg-12">
                        <input type="text" placeholder="First and Last Name" value="Tom Smith" />
                        <input type="text" placeholder="Email" value="mail@example.com" />
                        <input type="text" placeholder="Phone" value="+12 345 678 910" />
                        <textarea name="" id="" cols="10" rows="2" placeholder="Message"></textarea>
                    </div>

                    <div class="col-lg-12">
                        <div class="preferred-contact-method">
                            <h5>Preferred contact method</h5>

                            <div class="preferred-contact-radios">
                                <div class="radio">
                                    <input id="radio-1" name="radio" type="radio" checked />
                                    <label for="radio-1"><span class="radio-label"></span> Email</label>
                                </div>

                                <div class="radio">
                                    <input id="radio-2" name="radio" type="radio" />
                                    <label for="radio-2"><span class="radio-label"></span> Phone</label>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {/* <!-- Reply to review popup --> */}
                {/* <div id="small-dialog" class="zoom-anim-dialog mfp-hide">
                    <div class="small-dialog-header">
                        <h3>Send Message</h3>
                    </div>
                    <div class="message-reply margin-top-0">
                        <textarea cols="40" rows="3" placeholder="Your message to Tom"></textarea>
                        <button class="button">Send Message</button>
                    </div>
                </div> */}

                <a href="#small-dialog" class="send-message-to-owner button popup-with-zoom-anim"><i class="sl sl-icon-envelope-open"></i> Send Message</a>
            </div>
        </>
    )
}